export enum DS6WStatus {
  Out = 'ds6w:status.swym_inactive',
}
